var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "GetStartedLayout",
    {
      attrs: {
        errors: _vm.errors,
        guest: _vm.guest,
        child: _vm.child,
        helpForm: false,
        locations: _vm.locations,
        location: _vm.locations.find((e) => e.id == _vm.form.location_id),
        review: _vm.review,
        stepNumber: _vm.stepNumber,
        hideFab: "",
        title: _vm.currentStep.title,
        subtitle:
          _vm.currentStep.name == "form"
            ? `Risk free with our
            <a
                href='https://musicologielessons.com/why-choose-musicologie'
                target='_blank'
                class='white--text'
            >
                Perfect Match Promise</a
            >`
            : _vm.currentStep.subtitle,
      },
    },
    [
      _c(
        "v-window",
        {
          staticClass: "elevation-0 w-full pa-0",
          staticStyle: { background: "transparent" },
          attrs: { touchless: "" },
          model: {
            value: _vm.stepNumber,
            callback: function ($$v) {
              _vm.stepNumber = $$v
            },
            expression: "stepNumber",
          },
        },
        _vm._l(_vm.stepData, function (step) {
          return _c(
            "div",
            { key: step.name },
            [
              _c(
                "v-window-item",
                {
                  staticClass: "px-3 custom-stepper",
                  staticStyle: { overflow: "visible" },
                  attrs: { step: _vm.stepData.indexOf(step) },
                },
                [
                  _vm.currentStep.name == step.name
                    ? _c(
                        step.comp,
                        _vm._g(
                          _vm._b(
                            {
                              key: step.name,
                              tag: "component",
                              class: step.classes,
                              model: {
                                value: _vm.form[step.name],
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, step.name, $$v)
                                },
                                expression: "form[step.name]",
                              },
                            },
                            "component",
                            { ...step.props() },
                            false
                          ),
                          step.on
                        )
                      )
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _vm.stepNumber
        ? _c("WindowMarker", {
            staticClass: "mt-1",
            attrs: { length: _vm.stepData.length },
            on: {
              input: function ($event) {
                return _vm.clearFutureSteps($event)
              },
            },
            model: {
              value: _vm.stepNumber,
              callback: function ($$v) {
                _vm.stepNumber = $$v
              },
              expression: "stepNumber",
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }